module.exports = __webpack_public_path__ + "img/v4_followFundDetail.470359cd.png";